import React, { useState } from "react";
import LeaveManagementTable from "./LeaveManagementTable";
import { useNavigate } from "react-router-dom";
import LeaveHeader from "./LeaveHeader";
import AddLeaveModal from "./modal/AddLeaveModal";
import Cards from "./Cards";
import { cleanLeaveBal } from "../../../features/dropdown/dropdownSlice";
import { useDispatch } from "react-redux";

function LeaveMangementList() {
  const dispatch =  useDispatch()
  const handleAddLeave = async () => { 
   await dispatch(cleanLeaveBal())
    await setopen(true);
  };
  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  async function handleFetch() {}
  return (
    <div className="w-full h-full overflow-y-scroll bg-[#F8F9FA]">
      <LeaveHeader handleAddLeave={handleAddLeave} />
      <Cards/>
      <div>
        <LeaveManagementTable />
      </div>

      <AddLeaveModal
        handleFetchData={handleFetch}
        open={open}
        handleCancel={handleCancel} 
      />
    </div>
  );
}

export default LeaveMangementList;
